import { useLocation, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const hiddenPaths = ["/quote", "/dashboard", "/admin", "/auth", "/login", "/register"];

const StickyMobileCTA = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const shouldHide = hiddenPaths.some(p => location.pathname.startsWith(p));
  if (shouldHide) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-card/95 backdrop-blur-lg border-t border-border px-4 py-3 safe-area-bottom">
      <Button
        onClick={() => navigate("/quote")}
        className="w-full h-12 bg-accent hover:bg-accent/90 text-accent-foreground font-semibold rounded-xl shadow-lg shadow-accent/25 gap-2 text-base"
      >
        Gratis offertes aanvragen
        <ArrowRight className="w-5 h-5" />
      </Button>
    </div>
  );
};

export default StickyMobileCTA;
